import { Component, OnInit, HostBinding, HostListener } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, PRIMARY_OUTLET } from '@angular/router';

import { filter } from 'rxjs/operators';
import { map } from 'rxjs/internal/operators';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  @HostBinding('class.monitor-header-collapsed') get monitorHeaderCollapsed(): boolean {
    return this.isMonitorPage && this.collapsed;
  }

  public breadcrumbs;
  public title: string
  public isMonitorPage = false;
  public collapsed = false;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }))
      .pipe(filter(route => route.outlet === PRIMARY_OUTLET))
      .subscribe(route => {
        let title = route.snapshot.data['title'];
        let parent = route.parent.snapshot.data['breadcrumb'];
        let child = route.snapshot.data['breadcrumb'];
        this.breadcrumbs = {};
        this.title = title;
        this.isMonitorPage = this.router.url.split('?')[0] === '/limpia-publica/monitor';
        if (!this.isMonitorPage) {
          this.collapsed = false;
        }
        document.body.classList.toggle('monitor-header-collapsed', this.isMonitorPage && this.collapsed);
        this.breadcrumbs = {
          "parentBreadcrumb": parent,
          "childBreadcrumb": child
        }
      });
  }

  ngOnInit() { }

  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
    document.body.classList.toggle('monitor-header-collapsed', this.isMonitorPage && this.collapsed);
  }

  @HostListener('window:monitorHeaderToggle')
  onMonitorHeaderToggle(): void {
    if (this.isMonitorPage) {
      this.toggleCollapsed();
    }
  }

  ngOnDestroy() { }

}
